import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { ErrorIcon } from '../../utils/icons';
import { Box, Typography } from '../../utils/material-ui-core';

interface IDisplayErrorMessageProps {
  message: string;
}
const DisplayErrorMessage = ({ message }: IDisplayErrorMessageProps) => {
  const pageStyles = LocalPageStyles();

  return (
    <Box width={1} display="flex" justifyContent="center" alignItems="center" className={pageStyles.errorContainer}>
      <ErrorIcon fontSize="medium" />
      <Typography variant="body2" className={pageStyles.errorMessage}>
        {message}
      </Typography>
    </Box>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorContainer: {
      backgroundColor: theme.palette.error.contrastText,
      color: theme.palette.error.main,
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    errorMessage: {
      paddingLeft: 5,
    },
  })
);

export default DisplayErrorMessage;
